import {List} from 'immutable';
import NameAndNumber from '~/data/records/NameAndNumber';
// types
import NamesAndNumbersTypes from '~/constants/types/NamesAndNumbersTypes';
import {MAX_NAMES_AND_NUMBERS_PER_SIZE} from '~/constants/NamesAndNumbersConstants';
import DesignTypes from '~/constants/types/DesignTypes';
import ProductTypes from '~/constants/types/ProductTypes';
import QuoteTypes from '~/constants/types/QuoteTypes';
import {makeUndoable} from '~/utils/undoable';
export function initialState() {
  return List();
}

const getNamesAndNumbersSizes = state => {
  return state.reduce((hash, n) => {
    hash[n.productId] = hash[n.productId] || {};
    hash[n.productId][n.productSize] =
      hash[n.productId] && hash[n.productId][n.productSize]
        ? hash[n.productId][n.productSize] + 1
        : 1;
    return hash;
  }, {});
};
const getSizes = (newSizes, namesAndNumbersSizes, state) => size => {
  const styleId = Object.keys(newSizes)[0];
  let newState = state;
  Object.keys(size).map(k => {
    const matchingNamesAndNumbersSize =
      namesAndNumbersSizes[styleId] && namesAndNumbersSizes[styleId][k];
    const sizeDifference = size[k] - (matchingNamesAndNumbersSize || 0);
    sizeDifference > 0 &&
      new Array(sizeDifference).fill().map(() => {
        newState = newState.push(
          new NameAndNumber({productId: styleId, productSize: k})
        );
      });
  });
  return newState;
};

export function namesAndNumbers(state = initialState(), action) {
  switch (action.type) {
    case NamesAndNumbersTypes.CREATE: {
      return state.unshift(new NameAndNumber(action.payload));
    }
    case NamesAndNumbersTypes.BATCH_CREATE: {
      const {size, ...rest} = action.payload;
      let newState = state;
      if (
        !Number.isNaN(size) &&
        size > 0 &&
        size < MAX_NAMES_AND_NUMBERS_PER_SIZE
      ) {
        new Array(size).fill().map(() => {
          newState = newState.push(new NameAndNumber({...rest}));
        });
      }
      return newState;
    }
    case NamesAndNumbersTypes.REMOVE_EMPTY_NAMES_AND_NUMBERS: {
      const sizes = action.payload && {...action.payload};
      if (sizes) {
        return state.filter(n => {
          if (sizes[n.productSize] > 0 && !n.name && !n.number) {
            sizes[n.productSize] -= 1;
            return false;
          }
          return true;
        });
      }
      return state.filter(n => n.name || n.number);
    }
    case NamesAndNumbersTypes.REMOVE_INVALID_NAMES_AND_NUMBERS:
      return state.filter(n => n.name || n.number || n.productSize);
    case NamesAndNumbersTypes.UPDATE: {
      const {id} = action.payload;
      const updatedNameAndNumber = new NameAndNumber(action.payload);
      const index = state.findIndex(
        nameAndNumber => nameAndNumber.get('id') === id
      );
      return state.update(index, () => updatedNameAndNumber);
    }
    case NamesAndNumbersTypes.DELETE: {
      const {id} = action.payload;
      const index = state.findIndex(
        nameAndNumber => nameAndNumber.get('id') === id
      );
      return state.delete(index);
    }
    case ProductTypes.SWAP_PRODUCT: {
      if (state.size === 0) return state;
      const {nextColorId} = action.payload;
      return state.map(n => n.update('productId', () => nextColorId));
    }
    case ProductTypes.CHANGE_COLOR: {
      if (state.size === 0) return state;
      const {nextColorId} = action.payload;
      return state.map(n => n.update('productId', () => nextColorId));
    }
    case QuoteTypes.UPDATE_PRODUCT_QUANTITIES: {
      if (state.size === 0) return state;
      const {payload} = action;
      const namesAndNumbersSizes = getNamesAndNumbersSizes(state);
      const newState = Object.values(payload).map(
        getSizes(payload, namesAndNumbersSizes, state)
      )[0];
      return newState;
    }
    case DesignTypes.FETCH_SUCCESS: {
      return action.payload.namesAndNumbers;
    }
    case NamesAndNumbersTypes.CLEAR:
    case DesignTypes.CLEAR_DESIGN_DATA: {
      return initialState();
    }
    default:
      return state;
  }
}

export default makeUndoable(namesAndNumbers);
